
<template>
  <!-- PRODUCT CARD -->
  <div class="card" v-if="viewType === 'deluxe' || viewType === 'brilliant'">
    <header class="card-header compact">
      <p class="card-header-title compact">
        <a class="link is-info has-text-black" :href="userLink" target="_blank"> Last edited by: {{ userFullName }}</a>
      </p>
    </header>

    <footer class="card-footer">
      <a v-if="(action1 != null && action1.length > 0) && this.userRole != 'readonly'" v-on:click="runAction1" class="card-footer-item compact has-black">{{ action1.charAt(0).toUpperCase() + action1.substr(1) }}</a>
      <a v-if="(action2 != null && action2.length > 0) && this.userRole != 'readonly'" v-on:click="runAction2" class="card-footer-item compact has-black">{{ action2.charAt(0).toUpperCase() + action2.substr(1) }}</a>
      <a v-if="(action3 != null && action3.length > 0)" v-on:click="runAction3" class="card-footer-item">{{ action3.charAt(0).toUpperCase() + action3.substr(1) }}</a>
    </footer>
  </div>
  <div class="card" v-else>
    <header class="card-header">
      <div class="container is-paddingless">
        <nav class="level">
          <!-- Left side -->
          <div class="level-left">
            <div class="level-item">
              <p class="card-header-title"> {{ name }} </p>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">

              <p class="card-header-title">
                <a class="link is-info" :href="userLink" target="_blank"> Last edited by: {{ userFullName }}</a>
              </p>
            </div>
          </div>
        </nav>
      </div>
    </header>

    <div class="card-content">
      <div class="content">
        <p>{{ name }} </p>
      </div>
      <nav class="level">
        <p class="level-item has-text-centered">
          Group Id: {{ id }}
        </p>
      </nav>
    </div>
    <footer class="card-footer">
      <a v-if="(action1 != null && action1.length > 0) && this.userRole != 'readonly'" v-on:click="runAction1" class="card-footer-item">{{ action1.charAt(0).toUpperCase() + action1.substr(1) }}</a>
      <a v-if="(action2 != null && action2.length > 0) && this.userRole != 'readonly'" v-on:click="runAction2" class="card-footer-item">{{ action2.charAt(0).toUpperCase() + action2.substr(1) }}</a>
      <a v-if="(action3 != null && action3.length > 0)" v-on:click="runAction3" class="card-footer-item">{{ action3.charAt(0).toUpperCase() + action3.substr(1) }}</a>
    </footer>
  </div>
  <!-- END PRODUCT CARD -->
</template>

<script>
  export default {
    name: "products-group-card",
    props: {
      product: Object,
      action1: String, //Edit
      action2: String, //Delete
      action3: String //Changes file
    },
    data() {
      return {
        userName: "Johnessa",
        userFamilyName: "Doe"
      };
    },
    computed: {
      id: function () {
        return this.product.id;
      },
      name: function () {
        return this.product.name;
      },
      userFullName: function () {
        if (this.product.user != null)
          return this.product.user.name + " " + (this.product.user.familyName ? this.product.user.familyName : "");
        else return "John Doe";
      },
      userLink: function () {
        return process.env.PASSPORT_URI + "/Profile/Index/" + this.product.userId;
      }
    },
    methods: {
      runAction1() {
        this.$emit(this.action1, this.id);
      },
      runAction2() {
        this.$emit(this.action2, this.id);
      },
      runAction3() {
        this.$emit(this.action3, this.id);
      }
    },
    created() {
      this.HTTP.load();
      let serviceId = 3;
    }
  };
</script>

<style>
  .compact.card-header {
    background-color: whitesmoke;
  }

  .compact.card-header-title {
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .compact.card-content {
    padding: 0.75rem 1.5rem;
  }

  .compact.card-footer-item {
    padding-top: 0;
    padding-bottom: 0;
  }

  .is-info.card-footer-item {
    background-color: hsl(204, 86%, 53%);
    color: white;
  }

  .is-danger.card-footer-item {
    background-color: hsl(348, 100%, 61%);
    color: white;
  }

  .has-black.card-footer-item {
    color: black;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProductsGroupCard.Vue